var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 20,
    viewBox: "0 0 10.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M1466.66,88.833h2.505l1.005-4h-3.51v-2c0-1.03,0-2,2.01-2h1.5v-3.36a28.339,28.339,0,0,0-2.865-.14,4.33,4.33,0,0,0-4.635,4.7v2.8h-3v4h3v8.5h3.99Z",
    transform: "translate(-1459.67 -77.333)",
    fill: "#0057af"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7f7a52541ca0fc9695f90b5af07b1a8e.svg";
export { ForwardRef as ReactComponent };